import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./WaitlistForm.css";

export default function WaitlistForm() {
    const form = useRef();
    const [status, setStatus] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const SHEETDB_URL = "https://sheetdb.io/api/v1/tzfh1qd1t0aub";

    const sendToSheet = async (data) => {
        const res = await fetch(SHEETDB_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ data: [data] }),
        });
        if (!res.ok) throw new Error("SheetDB error");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;              // guard against double‐click
        setIsSubmitting(true);
        setStatus("⏳ Please wait...");

        const data = Object.fromEntries(new FormData(form.current).entries());

        try {
            await emailjs.sendForm(
                "C01df7pm7",
                "template_3atqn2w",
                form.current,
                "xSf-viwnITdLBea5T"
            );
            await sendToSheet(data);
            setStatus("✅ You're on the waitlist!");
            // form.current.reset();
        } catch (err) {
            console.error(err);
            setStatus("❌ Something went wrong.");
        } finally {
            // re-enable after 3 seconds
            setTimeout(() => {
                setIsSubmitting(false);
                setStatus("");                     // clear status or keep it
            }, 3000);
        }
    };

    return (
        <div className="bodywait">
            <h2 className="waitlist-title">Join Our Waitlist</h2>
            <div className="p-wrapper">
                <p>
                    To get updates on our progress, sneak peeks into what we're working on, and to be the first to know
                    when we launch, please join our waitlist.
                </p>
            </div>
            <div className="waitlist-wrapper">
                <form
                    ref={form}
                    onSubmit={handleSubmit}
                    className="waitlist-form"
                >
                    <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        required
                        disabled={isSubmitting}
                    />
                    <input
                        name="first_name"
                        type="text"
                        placeholder="First Name"
                        required
                        disabled={isSubmitting}
                    />
                    <input
                        name="last_name"
                        type="text"
                        placeholder="Last Name"
                        required
                        disabled={isSubmitting}
                    />
                    <input
                        name="dealership"
                        type="text"
                        placeholder="Dealership/Automotive Group"
                        required
                        disabled={isSubmitting}
                    />

                    <button type="submit" disabled={isSubmitting}>
                        {isSubmitting ? "Submitting…" : "Join Waitlist"}
                    </button>
                    {status && <p className="status-message">{status}</p>}
                </form>
            </div>
        </div>
    );
}
